/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconMail16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconMail16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.334 6.667c0-1.243 0-1.864.203-2.354.27-.653.79-1.172 1.443-1.443.49-.203 1.111-.203 2.354-.203h5.333c1.243 0 1.864 0 2.354.203.653.27 1.173.79 1.443 1.443.203.49.203 1.111.203 2.354v2.667c0 1.242 0 1.863-.203 2.354a2.667 2.667 0 0 1-1.443 1.443c-.49.203-1.111.203-2.354.203H5.334c-1.243 0-1.864 0-2.354-.203a2.667 2.667 0 0 1-1.443-1.444c-.203-.49-.203-1.11-.203-2.353V6.667Zm1.334-.462v3.129c0 .64 0 1.052.022 1.368.02.304.056.42.079.475.135.327.395.587.721.722.056.023.172.058.476.079.316.022.728.022 1.368.022h5.333c.64 0 1.053 0 1.369-.022.304-.02.42-.056.475-.08.327-.134.586-.394.722-.72.022-.056.058-.172.079-.476.021-.316.022-.729.022-1.368V6.214L8.666 8.9c-.412.237-.92.237-1.332-.001L2.668 6.205ZM13.2 4.752a1.333 1.333 0 0 0-.69-.65c-.056-.023-.171-.059-.475-.08A22.546 22.546 0 0 0 10.667 4H5.334c-.64 0-1.052.001-1.368.023-.304.02-.42.056-.476.079-.3.124-.543.353-.685.643l5.196 3 5.2-2.993Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconMail24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconMail24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 10c0-1.864 0-2.796.304-3.53A4 4 0 0 1 4.47 4.303C5.204 4 6.136 4 8 4h8c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165C22 7.204 22 8.136 22 10v4c0 1.864 0 2.796-.305 3.53a4 4 0 0 1-2.164 2.165C18.796 20 17.864 20 16 20H8c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164C2 16.796 2 15.864 2 14v-4Zm2-.693V14c0 .96.001 1.579.033 2.052.032.457.085.63.12.713a2 2 0 0 0 1.082 1.083c.083.034.257.088.713.119C6.42 17.999 7.04 18 8 18h8c.96 0 1.578-.001 2.052-.033.457-.031.63-.085.713-.12a2 2 0 0 0 1.083-1.082c.034-.083.088-.256.119-.713C19.999 15.58 20 14.96 20 14V9.32l-7.002 4.03A2 2 0 0 1 11 13.347l-7-4.04Zm15.8-2.179a2 2 0 0 0-1.035-.976c-.083-.034-.256-.087-.713-.119C17.578 6.001 16.96 6 16 6H8c-.96 0-1.579.001-2.052.033-.456.032-.63.085-.713.12a2 2 0 0 0-1.03.963l7.795 4.5 7.8-4.488Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconMail = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconMail(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconMail16 {...iconProps} />;
        case '24':
            return <IconMail24 {...iconProps} />;
        default:
            return <IconMail24 {...iconProps} />;
    }
});
